import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+500',
  label: 'docentes confían'
}, {
  value: '5',
  label: 'Cuadernillos listos'
}, {
  value: '4.9/5',
  label: 'calificación',
  hasStar: true
}, {
  value: '🌎',
  label: 'Educación secundaria'
}];
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  location: 'Bogotá, Colombia',
  specialty: 'Educación secundaria',
  quote: '"Organicé todo el año en una tarde"',
  color: 'bg-blue-600'
}, {
  initials: 'MG',
  name: 'Martín G.',
  location: 'Lima, Perú',
  specialty: 'Educación secundaria',
  quote: '"Mis clases de Química por fin enganchan"',
  color: 'bg-indigo-600'
}, {
  initials: 'LG',
  name: 'Laura G.',
  location: 'Santiago, Chile',
  specialty: 'Educación secundaria',
  quote: '"Nunca más improvisé una evaluación"',
  color: 'bg-sky-600'
}];
export function SocialProof() {
  return <section className="py-4 md:py-8 px-4 max-w-7xl mx-auto -mt-4 md:-mt-12 relative z-10" data-id="element-269">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-270">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="text-center" data-id="element-271">
            <div className="flex items-center justify-center gap-1 mb-1 md:mb-2" data-id="element-272">
              <span className="text-3xl md:text-5xl font-black text-blue-600" data-id="element-273">
                {stat.value}
              </span>
              {stat.hasStar && <Star className="fill-amber-400 text-amber-400 w-4 h-4 md:w-6 md:h-6" data-id="element-274" />}
            </div>
            <p className="text-slate-600 font-bold text-[10px] md:text-base uppercase tracking-wide" data-id="element-275">
              {stat.label}
            </p>
          </motion.div>)}
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-276">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1 + 0.4
      }} className="bg-white p-6 md:p-8 rounded-3xl shadow-xl shadow-blue-900/5 border border-blue-50 relative overflow-hidden group" data-id="element-277">
            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-278">
              <div className={`${t.color} w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl flex items-center justify-center text-white font-black text-base md:text-lg shadow-lg`} data-id="element-279">
                {t.initials}
              </div>
              <div data-id="element-280">
                <div className="flex gap-0.5 mb-1" data-id="element-281">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-amber-400 text-amber-400" data-id="element-282" />)}
                </div>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-tighter" data-id="element-283">
                  Verificado
                </p>
              </div>
            </div>
            <blockquote className="text-base md:text-lg font-bold text-slate-800 mb-4 md:mb-6 leading-tight" data-id="element-284">
              {t.quote}
            </blockquote>
            <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-slate-50" data-id="element-285">
              <div className="text-xs md:text-sm" data-id="element-286">
                <p className="font-black text-slate-900" data-id="element-287">{t.name}</p>
                <div className="flex items-center gap-1 text-slate-500 font-medium" data-id="element-288">
                  <MapPin size={12} data-id="element-289" />
                  <span data-id="element-290">
                    {t.location} | {t.specialty}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}